/**
 * SEQUENCING RESOLVER (MEV5)
 * Mechanism: Nutrient Ordering & Viscosity Shield
 * Source: 2024 Gastric Flux Mapping
 */

export type SequencingStrategy = 'MIXED' | 'CARBS_FIRST' | 'BUFFERED' | 'FIBER_PROTEIN_FIRST';

export const SequencingResolver = {
    
    /**
     * Calculates the carb delay multiplier based on meal strategy.
     * @param strategy The user-logged sequencing strategy.
     * @returns 0.65 (Buffered) to 1.1 (Fasted Spike)
     */
    getCarbDelayMod(strategy: SequencingStrategy): number {
        switch (strategy) {
            case 'BUFFERED':
            case 'FIBER_PROTEIN_FIRST':
                // Source: 2024 experimental data on fiber matrix suppression
                return 0.65;
            case 'CARBS_FIRST':
                return 1.1; // Slight acceleration for fasted state spikes
            case 'MIXED':
            default:
                return 1.0;
        }
    }
};
